import jquery from "jquery"
import {mapConfig} from "./gisConfig.js"
import TitleMarker from "./class/TitleMarker.js"
import WidgetManager from "./module/WidgetManager.js"
import MapManager from "./module/MapManager.js"

let _map
let _vectorLayer
let _widgetManager = undefined
let _mapManager = undefined

function init() {
  ///////////////扩展jquery，增加观察者模式自定义事件///////////////////
  if ("undefined" == typeof jquery) {
    throw new Error("requires jquery");
  }

  let o = jquery({});
  jquery.each({
    trigger: 'publish',
    on: 'subscribe',
    off: 'unsubscribe'
  }, function (key, val) {
    jquery[val] = function () {
      o[key].apply(o, arguments);
    };
  });
  /////////////////////////////////////////////////////////////////

  /*if ("undefined" == typeof THREE){
      throw new Error("requires THREE");
  }
  else{
      console.log(THREE);
  }*/

  window._iIntervalNum = 200;
}

init();

export function createMap(domId, options) {
  _mapManager = new MapManager()
  _map = _mapManager.createMap(domId, options)
  _vectorLayer = _mapManager.getVectorLayer();
  _widgetManager = new WidgetManager({map: _map})

  return _map;
}

export function addGraphics(graphics) {
  if (Array.isArray(graphics)) {
    for (let i = 0, iMax = graphics.length; i < iMax; ++i) {
      _vectorLayer.addGeometry(graphics[i]);
    }
  } else if (graphics) {
    _vectorLayer.addGeometry(graphics);
  }
}

export function clearMap() {
  _vectorLayer.clear()
  jquery.publish("clearMapEvent");
}

//getAddressByPoint(x,y,gisType,callback)
export function getAddressByPoint(...args) {
  let x = args.shift();
  x = Number(x);
  if (isNaN(x)) {
    alert("参数x错误！");
    return;
  }
  let y = (args.length > 0) ? args.shift() : undefined;
  y = Number(y);
  if (isNaN(y)) {
    alert("参数y错误！");
    return;
  }
  const callback = (typeof args[args.length - 1] === 'function') ? args.pop() : undefined;
  if (!callback) {
    alert("缺少callback参数！");
    return;
  }
  const gisType = (args.length > 0) ? args.shift() : "td";

  if (gisType === "td") {
    let queryObj = {}
    queryObj.lon = x
    queryObj.lat = y
    queryObj.ver = 1
    let queryStr = JSON.stringify(queryObj)
    let queryUrl = mapConfig.tdApiUrl + "&type=geocode&postStr=" + queryStr

    jquery.get(queryUrl, function (objResult) {
      let addrObj = {result: false}
      objResult = JSON.parse(objResult)
      //console.log("getAddressByPoint:", objResult)
      if (objResult && objResult.status === "0" && objResult.msg === "ok") {
        addrObj.address = objResult.result.formatted_address
        addrObj.poi = objResult.result
        addrObj.result = true
      }
      callback(addrObj)
    })
  } else if (gisType === "bd") {
    let queryUrl = mapConfig.bdApiUrl + "&coordtype=wgs84ll&location=" + y + "," + x

    //jquery.get(queryUrl, function (objResult){
    jquery.ajax({
      url: queryUrl,
      type: "GET",
      dataType: "jsonp",
      success: function (objResult) {
        let addrObj = {result: false}
        //console.log("getAddressByPoint:", objResult)
        if (objResult && objResult.status === 0) {
          addrObj.address = objResult.result.formatted_address
          addrObj.poi = objResult.result
          addrObj.result = true
        }
        callback(addrObj)
      }
    })
  }
}

//getPointByAddress(address, gisType, callback)
export function getPointByAddress(...args) {
  let address = (args.length > 0) ? args.shift() : undefined;
  if (!address) {
    alert("缺少address参数！");
    return;
  }
  const callback = (typeof args[args.length - 1] === 'function') ? args.pop() : undefined;
  if (!callback) {
    alert("缺少callback参数！");
    return;
  }
  const gisType = (args.length > 0) ? args.shift() : "td";

  if (gisType === "td") {
    let queryObj = {};
    queryObj.keyWord = address;
    let queryStr = JSON.stringify(queryObj);
    let queryUrl = mapConfig.tdApiUrl + "&ds=" + queryStr;
    jquery.get(queryUrl, function (objResult) {
      let retObj = {result: false};
      objResult = JSON.parse(objResult);
      //console.log("getAddressByPoint:", objResult);
      if (objResult && objResult.status === "0" && objResult.msg === "ok") {
        retObj.result = true;
        retObj.x = objResult.location.lon;
        retObj.y = objResult.location.lat;
      }
      callback(retObj);
    })
  } else if (gisType === "bd") {
    let queryUrl = mapConfig.bdApiUrl + "&address=" + address;
    queryUrl = queryUrl.replace("reverse_geocoding", "geocoding");
    jquery.ajax({
      url: queryUrl,
      type: "GET",
      dataType: "jsonp",
      success: function (objResult) {
        let retObj = {result: false};
        //console.log("getAddressByPoint:", objResult);
        if (objResult && objResult.status === 0) {
          retObj.result = true;
          retObj.x = objResult.result.location.lng;
          retObj.y = objResult.result.location.lat;
        }
        callback(retObj);
      }
    });
  }
}

export {TitleMarker}



// WEBPACK FOOTER //
// ./src/components/EXGis/maptalksExt.js